import {
    REQUEST_PASSWORD_LIST,
    RECEIVE_PASSWORD_LIST,
    SET_RECORD_EXT_ID,
    SET_PASSWORD_DETAILS,
    LOADING_PASSWORD_LIST,
    TOGGLE_FAVOURITE,
    IPasswordManagerState,
    PasswordManagerTypes,
} from "./types";

const initialState: IPasswordManagerState = {
    passwordList: [],
    selectedPasswordRecordExtId: "",
    selectedPasswordDetails: {},
    loadingPasswordList: false,
};

export function passwordManagerReducer(state = initialState, action: PasswordManagerTypes): IPasswordManagerState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_PASSWORD_LIST:
            return {
                ...state,
                passwordList: state.passwordList,
            };
        case LOADING_PASSWORD_LIST:
            return {
                ...state,
                loadingPasswordList: action.loadingPasswordList,
            };
        case RECEIVE_PASSWORD_LIST:
            return {
                ...state,
                passwordList: action.passwordList,
            };
        case SET_PASSWORD_DETAILS:
            return {
                ...state,
                selectedPasswordDetails: action.selectedPasswordDetails,
            };
        case TOGGLE_FAVOURITE:
            const index = state.passwordList.findIndex((item) => item.recordExtId === action.selectedPasswordRecordExtId);
            const favorite = state.passwordList[index].favorite === 0 ? 1 : 0;

            return {
                ...state,
                passwordList: [
                    ...state.passwordList.slice(0, index),
                    {
                        ...state.passwordList[index],
                        favorite: favorite,
                    },
                    ...state.passwordList.slice(index + 1),
                ],
            };
        case SET_RECORD_EXT_ID:
            return {
                ...state,
                selectedPasswordRecordExtId: action.selectedPasswordRecordExtId,
            };
        default:
            return state;
    }
}
